<template>
    <div class="form-materia-prima p-4 mt-4 bg-white border rounded shadow-sm">
      <h3 class="mb-4">Editar Materia Prima</h3>
  
      <form @submit.prevent="submitForm">
  
        <div class="mb-3">
          <label>Biomasa Origen</label>
          <input :value="biomasaDescripcion" class="form-control bg-light" readonly />
        </div>
  
        <div class="mb-3">
          <label>Tipo de Materia Prima</label>
          <input :value="tipoDescripcion" class="form-control bg-light" readonly />
        </div>
  
        <div class="mb-3">
          <label>Código</label>
          <input v-model="form.codigo" class="form-control bg-light" readonly />
        </div>
  
        <!-- Cantidad, Unidad de Medida, Humedad -->
        <div class="row mb-3 bg-light p-3 rounded">
          <div class="col-md-4">
            <label>Cantidad</label>
            <input v-model.number="form.cantidad" type="number" class="form-control" required />
          </div>
          <div class="col-md-4">
            <label>Unidad de Medida</label>
            <select v-model="form.unidad_medida" class="form-select" required>
              <option v-for="u in unidadesMedida" :key="u" :value="u">{{ u }}</option>
            </select>
          </div>
          <div class="col-md-4">
            <label>Humedad (%)</label>
            <input v-model.number="form.humedad_porcentaje" type="number" class="form-control" />
          </div>
        </div>
  
        <div class="mb-3">
          <label>Fecha Fin Secado/Curado</label>
          <input v-model="form.fecha_fin_secado" type="date" class="form-control" required />
        </div>
  
        <!-- Fecha de vencimiento + Días juntos -->
        <div class="row mb-3 bg-light p-3 rounded">
          <div class="col-md-6">
            <label>Fecha de Vencimiento</label>
            <input v-model="form.fecha_vencimiento" type="date" class="form-control" @change="onVencimientoChange" required />
          </div>
          <div class="col-md-6">
            <label>Días hasta vencimiento</label>
            <input v-model.number="diasVencimiento" type="number" class="form-control" @input="onDiasChange" min="0" />
          </div>
        </div>
  
        <div class="mb-3">
          <label>Comentarios</label>
          <textarea v-model="form.nota_calidad" class="form-control" rows="3"></textarea>
        </div>
  
        <div class="d-flex justify-content-end gap-2">
          <button type="button" @click="$emit('cancelar')" class="btn btn-outline-secondary">Cancelar</button>
          <button type="submit" class="btn btn-primary">Actualizar Materia Prima</button>
        </div>
  
      </form>
    </div>
  </template>
  
  <script>
  import axios from '@/axios';
  import { mapGetters } from 'vuex';
  import { format, differenceInCalendarDays, addDays } from 'date-fns';
  
  export default {
    name: 'FormMateriaPrimaEditar',
    props: {
      materia_id: { type: [Number, String], required: true }
    },
    data() {
      return {
        form: {},
        tiposMateria: [],
        unidadesMedida: [],
        biomasa: null,
        diasVencimiento: null
      };
    },

    
    mounted() {

      this.fetchMateriaPrima();
    },
    computed: {
      ...mapGetters(['getClubActual']),
      club_id() {
        return this.getClubActual.id;
      },
      biomasaDescripcion() {
        return this.biomasa
          ? `${this.biomasa.tipo_biomasa} (${this.biomasa.peso} ${this.biomasa.unidad_medida})`
          : '-';
      },
      tipoDescripcion() {
        const tipo = this.tiposMateria.find(t => t.id === this.form.tipo);
        return tipo ? tipo.descripcion : '-';
      }
    },
    async created() {
      await this.fetchTipos();
      await this.fetchUnidades();
      await this.fetchMateriaPrima();
    },
    methods: {
      async fetchTipos() {
        const res = await axios.get('/api/constantes/tipos_de_materia_prima');
        this.tiposMateria = res.data;
      },
      async fetchUnidades() {
        const res = await axios.get('/api/constantes/unidades-medida');
        this.unidadesMedida = res.data;
      },
      async fetchMateriaPrima() {
        const res = await axios.get(`/api/materia_prima/${this.materia_id}`, { params: { club_id: this.club_id } });
        this.form = res.data;
  
        this.form.fecha_fin_secado = this.form.fecha_fin_secado?.split('T')[0] || '';
        this.form.fecha_vencimiento = this.form.fecha_vencimiento?.split('T')[0] || '';
  
        this.biomasa = res.data.biomasa;
  
        if (this.form.fecha_vencimiento) {
          this.diasVencimiento = differenceInCalendarDays(new Date(this.form.fecha_vencimiento), new Date());
        }
      },
      onVencimientoChange() {
        if (this.form.fecha_vencimiento) {
          this.diasVencimiento = differenceInCalendarDays(new Date(this.form.fecha_vencimiento), new Date());
        } else {
          this.diasVencimiento = null;
        }
      },
      onDiasChange() {
        if (this.diasVencimiento != null) {
          this.form.fecha_vencimiento = format(addDays(new Date(), this.diasVencimiento), 'yyyy-MM-dd');
        }
      },
      async submitForm() {
        await axios.put(`/api/materia_prima/${this.materia_id}`, this.form);
        alert('Materia Prima actualizada');
        this.$emit('materiaPrimaEditada', this.form);
      }
    }
  };
  </script>
  
  <style scoped>
  .form-materia-prima {
    width: 100%;
  }
  </style>
  